import {useEffect, useRef, useState} from "react";
import {useSearchParams, useNavigate} from 'react-router-dom';
import Search from "../components/search";
import Vehicle from "../components/vehicle";
import {GetVehicles} from "../api/vehicles";
import Loader from '../components/loader'
import Header from '../components/header'
import ticketIcon from '../icons/ticket.svg'
import arrowRightIcon from '../icons/arrow-right.svg'
import Offer from '../components/offer'

const HistoryLink = () => {
    const navigate = useNavigate()
    return <div className={"tickets"} onClick={e => {
        navigate("/orders")
    }}>
        <div className={"tickets-icon"}>
            <img style={{width: 24, height: 24}} src={ticketIcon}/>
        </div>
        <div className={"tickets-title"}>
            <div className={"tickets-title-title"}>Мои поездки</div>
            <div className={"tickets-title-subtitle"}>Активные и история поездок</div>
        </div>
        <div className={"tickets-link"}>
            <img style={{width: 24, height: 24}} src={arrowRightIcon}/>
        </div>
    </div>
}


const VehicleLoader = ({visible}) => {
    return visible ? <div className={"vehicles-loader"}>
        <Loader visible={true}/>
        <div style={{marginTop: 8}}>Ищем транспортные<br/>средства</div>
    </div> : null
}

const Vehicles = ({lat, lng, forceLocation}) => {
    const navigate = useNavigate()
    const [location, setLocation] = useState({lat,lng})

    const loadingTimer = useRef()
    const [searchParams] = useSearchParams();
    const [vehicle, setVehicle] = useState(null)
    const [vehicles, setVehicles] = useState([])
    const [loading, setLoading] = useState(false)
    const [vehiclesQuery, setVehiclesQuery] = useState({})

    const loadVehicles = () => {
        setLoading(true)
        GetVehicles(location.lat, location.lng, vehiclesQuery.search)
            .then(setVehicles)
            .catch(() => {
            })
    }

    const searchVehicles = (search) => {
        setVehiclesQuery({search})
    }

    useEffect(() => {
        loadVehicles()
    }, [vehiclesQuery])

    useEffect(() => {
        if (!forceLocation && navigator.geolocation) {
            console.log("navigator enabled")
            navigator.geolocation.watchPosition((position)=>{
                console.log(position)
                setLocation({lat: position.coords.latitude, lng: position.coords.longitude})
            }, console.log,{
                enableHighAccuracy: true,
                maximumAge: 15000,
                timeout: 5000
            })
        }
    }, []);


    useEffect(() => {
        clearTimeout(loadingTimer.current)
        setLoading(vehicles.length === 0)
        setVehicle(null)

        if (vehicles.length === 1) {
            setVehicle(vehicles[0])
        } else if (vehicles.length === 0) {
            setVehicle(null)
            loadingTimer.current = setTimeout(() => {
                loadVehicles()
            }, 5000)
        }
        return () => clearTimeout(loadingTimer.current)
    }, [vehicles]);

    return <div className={"container page"}>
        <Header title={"Оплатить проезд"}/>
        <VehicleLoader visible={loading}/>
        <HistoryLink/>
        <div className={"vehicles"}>
            <Search search={searchVehicles} loading={loading} loadVehicles={loadVehicles} vehicles={vehicles}/>
            {
                vehicles.map((v, i) => <Vehicle
                    key={i}
                    vehicle={v}
                    selectedVehicle={vehicle}
                    setVehicle={setVehicle}
                    loading={loading}/>)
            }
        </div>
        <div className={"payment"}>
            {!vehicle && <button className={"payment-button"} disabled={true}>Выберите маршрут</button>}
            {vehicle &&
                <button className={"payment-button"}
                        onClick={() => navigate('/approval', {state: {vehicle: vehicle}})}>Далее</button>}
            <Offer vehicleId={vehicle?.id}/>
        </div>
    </div>
}

export default Vehicles